import styled from 'styled-components';
import { rgba } from 'polished';
import { COLOR_RED, COLOR_GREEN } from '../../../assets/styles/colors';
import { BP_MOBILE_MAX } from '../../../assets/styles/breakpoints';

export default styled.div`
  .modal-loading-wrap {
    display: flex;
    justify-content: center;
  }
  .top-text-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    h2 {
      max-width: 100%;
    }
  }
  .checkbox-wrap {
    padding-top: 24px;
    .hint {
      padding-top: 15px;
    }
  }
  .price-wrap {
    padding-top: 48px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;

    h2 {
      max-width: 100%;
      color: ${COLOR_GREEN};
      line-height: 90px;
      font-size: 72px;
      font-weight: 900;
    }
  }

  .loan-summary-wrap {
    margin-top: 24px;
    padding: 24px;
    border: 1px solid rgba(47, 46, 65, 0.2);
    border-radius: 12px;

    &--bottom {
      padding-top: 0px;
      display: flex;
      flex-direction: column;
      &__row {
        padding-bottom: 10px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        &:last-child {
          padding-bottom: 0px;
        }
      }
    }
  }

  .submit-wrap {
    margin-top: 48px;
    button {
      width: 100%;
    }
  }

  @media (max-width: ${BP_MOBILE_MAX}px) {
    .price-wrap {
      padding-top: 24px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;

      h2 {
        font-size: 45px;
        line-height: 50px;
      }
    }
  }
`;

export const ErrorWrapSC = styled.div`
  margin-top: 24px;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: ${rgba(COLOR_RED, 0.1)};
  p {
    &:last-child {
      line-height: 1.25;
    }
  }
`;
